import { cn } from '@/lib/utils';

interface LoadingProps {
  message?: string;
  className?: string;
}

export function Loading({ message = 'Loading...', className }: LoadingProps) {
  return (
    <div className={cn('flex h-full w-full flex-col items-center justify-center gap-4', className)}>
      <div className="relative h-16 w-16">
        {/* Outer ring */}
        <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-[#5777BA] border-t-transparent" />
        {/* Inner ring */}
        <div className="absolute inset-2 animate-spin rounded-full border-[3px] border-[#5777BA] border-t-transparent animation-delay-150" />
        {/* Center dot */}
        <div className="absolute inset-[18px] rounded-full bg-[#5777BA]" />
      </div>
      <p className="text-lg font-medium text-[#5777BA]">{message}</p>
    </div>
  );
}
